export default __webpack_public_path__ + "static/media/hang-up.945e586f.svg";